export const BaseUrls = {
  AUTH: "https://mslu2zw8n1.execute-api.ap-south-1.amazonaws.com/dev",
  DASHBOARD: "https://kayv5h12g8.execute-api.ap-south-1.amazonaws.com/dev",
  INTG: "https://xng6z3ipsl.execute-api.ap-south-1.amazonaws.com/dev",
};

export const BUCKETS = {
  ATS_BUCKET: "ats-admin-dev",
  PUBLIC_BUCKET: "symplora-common",
};

export enum ServiceType {
  AUTH = "AUTH",
  DASHBOARD = "DASHBOARD",
  INTG = "INTG",
}

export enum ApiType {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

export enum S3ActionType {
  UPLOAD = "UPLOAD",
  DOWNLOAD = "DOWNLOAD",
  DELETE = "DELETE",
}

export const ContentTypes = {
  JSON: "application/json; charset=UTF-8",
  FORM_DATA: "multipart/form-data",
};

export const ResponseType = {
  JSON: "json",
  BLOB: "blob",
};
